<template>
 <v-container :class="'mt-0 pt-0 '" fluid>
     <v-card
        class="pa-0 ma-0 mt-5 mb-5" 
        elevation="0" 
     >
        <v-row>
            <v-col cols="3" class="my0 py-0">
                <v-text-field 
                        class="mb-0 pb-0" 
                        :label="this.$t('cards.banks')"
                        :value="bankFilter"
                        @change="v => bankFilter = v"
                        :append-icon="'mdi-close'"
                        @click:append="()=>bankFilter=''"
                        :prepend-icon="'mdi-bank'"
                />
            </v-col>
            <v-col cols="7" class="my0 py-0"/>
            <v-col  cols="2" class="my0 py-0">
                <v-row>
                    <v-spacer/>
                    <SearchButtons
                        v-on:clear="clearFilters"
                        v-on:get="getData"
                    />
                </v-row>
            </v-col>
            <v-spacer/> 
        </v-row> 
     </v-card>
    <v-card>
        <v-card-title class="my-0 pb-1 pt-2 mt-3">
            <BankDialog
                v-if="this.$store.getters.CAN_ADD_BANKS"
                :mode="0"
                v-on:created="onCreated"
                v-on:error="onError"
            />
            <BankDialog 
                v-if="this.$store.getters.CAN_EDIT_BANKS && selectedBank.length == 1"
                :mode="1" 
                :bank="selectedBank[0]"
                v-on:saved="onSaved"
                v-on:error="onError"
            />
            <Confirm 
                v-if="this.$store.getters.CAN_DELETE_BANKS && selectedBank.length === 1"
                :title="deleteConfirmTitle"
                :text="confirmText"
                v-on:ok="() => onDelete(selectedBank[0])"
                :tooltipText="$t('confirm.deleteBank')"
            />
            <v-spacer/>
            {{$t('cards.total')}}: {{totalCount}} 
        </v-card-title>
        <LoadIcon v-if="loading"/>
        <LightTable
            :headers="headers"
            :items="banks"
            :loading="loading"
            itemKey="bankId"
            defaultSortColumn="bankName"
            :selectedItems="selectedBank"
            :markedItems="changedBanksId"
            :no-data-text="noDataText"
            :sortBy="sortBy"
            :sortDesc="sortDesc"
            mustSort
            v-on:changedSortDesc="onChangeSortDesc"
            v-on:changedSort="onChangeSort"
            singleSelect
            v-on:update="onUpdate"
            :height="tableHeight"
        />
    </v-card>
 </v-container>
</template>

<script>
import SearchButtons from '@/components/FiltersComponent/SearchButtons';
import BankDialog from '@/components/Dialogs/BankDialog';
import Vue from 'vue';
import LoadIcon from '@/components/LoadIcon';
import Confirm from '@/components/Confirm';
import LightTable from '@/components/Tables/LightTable';
import {notifyError, notifySuccess} from '@/services/notifications';
import tableHeightMixin from './mixins/tableHeightMixin';
import valIsNull from '@/services/valIsNull';

export default {
  name: 'Banks',
  components: {BankDialog, Confirm, LightTable, SearchButtons, LoadIcon},
  mixins: [tableHeightMixin],
  data() {
    return {
      noData: false,
      banks: [],

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 48,
      filterH: 56,
      tHeaderH: 44,
      tFooterH: 62,

      loading: false,
                
      selectedBank: [],
      changedBanksId:[],

      bankFilter: '',

      tempBanks: [],
      sortBy: [],
      sortDesc: [],

      limit: 10,
      page: 1,
      totalCount: '0',              
                
      apiUri: 'http://192.168.1.231/api',
                
    };
  },
  watch: {
    filterJson(){
      this.getData();
    }
  },
  computed: {
    propertiesResponse() {
      return {'Branches' : this.$t('errorsMessages.BankHasBranches')};
    }, 
    deleteConfirmTitle(){
      return this.$t('confirm.deleteBank') + ' ' +  this.selectedBank[0].bankName + '?';
    },
    confirmText(){
      return this.$t('confirm.text');
    },
    headers(){
      return [
        {text: '', value: '0', sortable: false, width: '100px'},
        {text: this.$t('referenceBooks.banks.Name'), value: 'bankName', sortable: true},
        {text: this.$t('referenceBooks.banks.Description'), value: 'description', sortable: true},
        {text: this.$t('referenceBooks.banks.Alias'), value: 'alias', sortable: true},
      ];
    },
    noDataText(){
      return this.$t('cards.noData');
    },
    filterJson() {
      const result = {};
      result.bankName = (!this.bankFilter) ? '' : this.bankFilter;

      return result;
    },

  },
  async mounted(){
    this.getData();
  },
  methods: {
    onUpdate(items){
      this.selectedBank = items;
      this.changedBanksId = [];
    },
    clearFilters(){
      this.bankFilter = '';
      this.getData();
    },  
    async getData(){
      this.selectedBank = [];
                
      if (this.loading) return;
                
      this.loading = true;
      const params = {
        'query': JSON.stringify(this.filterJson)
      };                
      this.getCount(params);
      params.limit = this.limit;
      params.offset = this.limit * (this.page - 1);
      this.executeRequest(params);
    },
    async getCount(params){
      this.$axios.banks.getCount(params)
        .then(response => response.data)
        .then(json => {
          this.paginationLength = Math.ceil(json.totalCount / this.limit);
          this.totalCount = json.totalCount;
        })
        .catch(error => {
          this.onError(error, this.$t('referenceBooks.banks.GetFailedCount'));
        });
    },
    async executeRequest(params){
      await this.$axios.banks.get(params)
        .then(response => response.data)
        .then(json => {
          this.tempBanks = this.sortData(json, this.sortBy, this.sortDesc);
          this.banks = this.tempBanks.slice(0, 500);
          this.loading = false;
          this.noData = this.banks == null || this.banks.length == 0;
        })
        .catch(error => {
          this.onError(error, this.$t('referenceBooks.banks.GetFailed'));
          this.loading = false;
        }); 
    },
    onChangeSort(sort){
      this.sortBy = sort;

      if(this.sortDesc.length === this.sortBy.length)
        this.banks = this.sortData(this.tempBanks, this.sortBy, this.sortDesc).slice(0, 500);

    },
    onChangeSortDesc(sortDesc){
      this.sortDesc = sortDesc;

      if(this.sortDesc.length === this.sortBy.length)
        this.banks = this.sortData(this.tempBanks, this.sortBy, this.sortDesc).slice(0, 500);
    },
    sortData(items, sortBy, desc){
      items.sort(function(a, b){
        let index = 0;

        while(index < sortBy.length){
          const isDesc = 
                            desc !== null && desc[index] !== null && desc[index] === true ? 
                              true : false;

          if(valIsNull(a[sortBy[index]]) && valIsNull(b[sortBy[index]]))
            return 0;
          if(valIsNull(a[sortBy[index]]))
            return isDesc ? -1 : 1;
          if(valIsNull(b[sortBy[index]]))
            return isDesc ? 1 : -1;

          if(a[sortBy[index]] > b[sortBy[index]])
            return isDesc ? -1 : 1;
          if(a[sortBy[index]] < b[sortBy[index]])
            return isDesc ? 1 : -1;
          index++;
        }

        return 0;
      });

      return items;
    },
    setDefaultSort(){
      this.sortBy = ['bankName'];
      this.sortDesc = [false];
    },
    async onDelete(bank){
      await this.$axios.banks.delete(bank.bankId)
        .then(() => {
          notifySuccess('', this.$t('Messages.BankWasDeleted', [bank.bankName]));
          this.getData();
        })
        .catch(error => {
          notifyError(this.$t('Error'), error);
          this.catchError(error, bank.bankName, this.$t('errorsMessages.Delete'));
        });
    },
    catchError(error, name, errorHeader = ''){
      // const messageResult = {header: '', message: ''};
      // const errorMessages = {
      //     message: message,
      //     noRights: this.$t('errorsMessages.NoRights'),
      //     propertiesResponse: this.propertiesResponse,
      // } 
      // referensesMethods.methods.catchError(messageResult, error, name, errorHeader, errorMessages);
      // this.showMessage(messageResult.header, messageResult.message, 'error');
      console.error(error);
      const status = error.response.status;
      const data = [error.response.data];

      const errorHeaderActual = errorHeader === '' ? this.$t('Error') : errorHeader;

      if (status === 400 || status === 401){
        for (let i = 0; i < data.length; i++){
          if (data[i].errorType === 'HAS_RELATIONS'){
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.propertiesResponse[data[i].property]}<br>${this.$t('referenceBooks.banks.Name')}: ${name}`,
              'error'
            );
          }
          else if (data[i].errorType === 'NO_RIGHTS'){
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.$t('errorsMessages.NoRights')}`,
              'error'
            );
          }
          else
            this.showMessage(errorHeaderActual, error, 'error');
        }         
      }
      else{                    
        this.showMessage(errorHeaderActual, error, 'error');
      }
    },
    markRow(id){
      this.changedBanksId = [];
      this.changedBanksId.push(id);
    },
    async onCreated(status, bankName, id){
      this.getData(); 
      if (status == 200){
        this.showMessage(this.$t('referenceBooks.banks.created'), `${this.$t('referenceBooks.banks.Name')}: ${bankName}`);
      }
      else
        this.showMessage(this.$t('referenceBooks.banks.created'), `${this.$t('referenceBooks.banks.Name')}: ${bankName}\n${this.$t('Status')}: ${status}`, 'warn');
                
      this.markRow(id);
    },
    async onSaved(status, bank){
      this.getData(); 
      if (status == 200)
        this.showMessage(this.$t('referenceBooks.banks.Saved'), `${this.$t('referenceBooks.banks.Name')}: ${bank.bankName}`);
      else
        this.showMessage(this.$t('referenceBooks.banks.Saved'), `${this.$t('referenceBooks.banks.Name')}: ${bank.bankName}\n${this.$t('Status')}: ${status}`, 'warn');
                
      this.markRow(bank.bankId);
    },
    async onError(error, errorHeader = ''){
      this.catchError(error, null, errorHeader);
    },
    showMessage(title, text, type = ''){
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
  }

};
</script>

<style >
    .darkBackground {
        background: #1E1E1E; 
    }
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .container {
        padding-top: 0;
        padding-bottom: 0;
    }
    v-messages__wrapper{
        min-height: 0;
    }

    .v-messages {
        min-height: 0px;
    }
    .v-text-field__details {
        min-height: 0px;
    }
</style>